// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCompareFlyOutStyles } from "@guestsupply/Overrides/Components/ProductCompareFlyOut";
import Close from "@guestsupply/XDL/Icons/Close";
import { color, mergeWithCss } from "@guestsupply/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

productCompareFlyOutStyles.carouselDrawer = {
    position: "bottom",
    size: 230,
    cssOverrides: {
        scrim: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            height: 125px;
                        `,
                    ],
                    "max",
                )}
        `,
        drawerBody: css`
            background: ${color("common.background")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            height: 125px;
                        `,
                    ],
                    "max",
                )}
        `,
        drawerTitle: css`
            background: ${color("common.background")};
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

productCompareFlyOutStyles.carouselDrawerContainer = {
    css: css`
        padding: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        display: none;
                    `,
                ],
                "max",
            )}
    `,
};

productCompareFlyOutStyles.removeProductFromCompareButton = {
    buttonType: "solid",
    color: "common.background",
    sizeVariant: "small",
    css: css`
        &:hover {
            background: none;
            border-color: transparent;
            & > ${IconWrapper} {
                color: ${color("common.ui6", 0.33)};
            }
        }
        &:focus {
            background: none;
            border-color: transparent;
        }
    `,
};

productCompareFlyOutStyles.removeProductFromCompareButtonIcon = {
    src: Close,
};

productCompareFlyOutStyles.headerTitleText = {
    variant: "h5",
    css: css`
        margin: 0;
    `,
};

productCompareFlyOutStyles.headerRemoveAllButton = {
    css: css`
        margin: 5px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex: 1;
                    `,
                ],
                "max",
            )}
    `,
    variant: "tertiary",
};

productCompareFlyOutStyles.carousel = {
    ...productCompareFlyOutStyles.carousel,
    carouselSlideInner: {
        ...mergeWithCss(productCompareFlyOutStyles.carousel?.carouselSlideInner, {
            css: css`
                max-height: 110px;
            `,
        }),
    },
};

productCompareFlyOutStyles.flyOutProduct = {
    productPriceStyles: {
        price: {
            priceText: {
                css: css`
                    white-space: nowrap;
                `,
            },
        },
    },
};
